<template>
  <div class="form-group">
    <vue-slider
      tooltip="false"
      :min="min"
      :max="max"
      step="1"
      :id="id"
      v-model="rangeValue"
      @input="emit"
    ></vue-slider>
    <label :for="id">{{ rangeValue }}</label>
    <div
      v-if="attribute.errors !== null"
      v-for="error in attribute.errors"
      :key="error"
      class="invalid-feedback"
    >
      {{ error }}
    </div>
  </div>
</template>

<script>
import { uniqueId } from "lodash";

export default {
  data() {
    return {
      rangeValue: 0,
      id: uniqueId()
    };
  },
  created() {
    this.rangeValue =
      this.value !== null ? this.value : (this.min + this.max) / 2;
  },
  computed: {
    max() {
      return this.attribute.max;
    },
    min() {
      return this.attribute.min;
    }
  },
  methods: {
    emit() {
      this.$emit("input", this.rangeValue);
    }
  },
  props: {
    value: {
      required: true
    },
    attribute: {
      required: true,
      type: Object
    }
  }
};
</script>
